// @flow
import ScheduleDay from './ScheduleDay';

export default ScheduleDay;
